import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.css']
})
export class MessageDialogComponent implements OnInit {

  message: string;
  type: string;

  constructor(private dialogRef: MatDialogRef<MessageDialogComponent>, @Inject(MAT_DIALOG_DATA) info) {
    //probably want to change design based on type, for now just put type in front of message
    this.message = info.message;
    this.type = info.type;
    this.dialogRef = dialogRef;
  }

  ngOnInit() {

  }

  close() {
    this.dialogRef.close();
  }

}
